import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { NSGridModule, NSSkeletonModule } from '@norfolk-southern/accessns-components';
import { NgxEchartsModule } from 'ngx-echarts';

import { ECRMetricsContainer } from '@ruby/modules/ecr/submodules/ecr-metrics/containers/ecr-metrics.container';
import { ECRMetricsRoutingModule } from '@ruby/modules/ecr/submodules/ecr-metrics/ecr-metrics-routing.module';

@NgModule({
  declarations: [ECRMetricsContainer],
  imports: [
    CommonModule,
    ECRMetricsRoutingModule,
    MatTabsModule,
    NgxEchartsModule,
    NSGridModule,
    NSSkeletonModule
  ]
})
export class ECRMetricsModule {}
